import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { HisInputWidget } from '../model/his-widget-input';

@Component( {
    selector: 'his-search-input',
    templateUrl: './his-search-input.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchInputComponent implements AfterViewInit {
    @Input() widget: HisInputWidget;

    @Input() isFirstInputElement = false;
    @ViewChild('inputElement') inputElement: ElementRef;

    @Output() changed = new EventEmitter<string>(); // type matches widget.value type

    ngAfterViewInit() {
        // Set name attribute for input autocomplete. Setting it directly in <input /> does not work 
        const sanitizedLabel = this.getSanitizedLabel();
        if (sanitizedLabel !== undefined) {
            this.inputElement.nativeElement.setAttribute('name', sanitizedLabel);
        }

        // Set focus on first input element unless input is in a wizard
        if (this.isFirstInputElement && document.querySelector('.wizardSteps') === null) {
            setTimeout( () => this.inputElement.nativeElement.focus() );
        }
    }

    getHtmlFocusElementId(): string {
        return this.widget.uid;
    }

    change( changes: string ) {
        console.log( 'HisSearchInputComponent.change(): Emit event', changes );
        this.changed.emit( changes );
    }
    
    getPlaceholder(): string {
        return this.widget.placeholder ? this.widget.placeholder : '';
    }
    
    getSanitizedLabel(): string {
        return this.widget.label.replace(/[^a-zA-Z0-9]/g, '_');
    }
}
